module.exports = __webpack_public_path__ + "static/media/intelij_small.73ce7efd.png";